module.exports = __webpack_public_path__ + "static/media/diplomado.0405f3b0.svg";